module.exports = __webpack_public_path__ + "img/birthday-2016.798d2253.jpg";